import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import AttendanceList from 'src/components/Attendance/AttendanceList';
import ApiErrorAlert from 'src/components/_common/ApiErrorAlert/ApiErrorAlert';
import PageHeader from 'src/components/_common/PageHeader/PageHeader';
import Spinner from 'src/components/_common/Spinner/Spinner';
import useSaveAttendance from 'src/hooks/attendance/useSaveAttendance';
import { AttendanceInput } from 'src/models/Attendance';
import { useStudentAttendancePageData } from './queries';

export default function StudentAttendancePage() {
  const { formatMessage } = useIntl();
  const { classId } = useParams<{ classId: string }>();
  const query = useStudentAttendancePageData(Number(classId ?? 0));
  const saveMutation = useSaveAttendance();

  if (!classId) return <Spinner />;
  if (query.isLoading) return <Spinner />;
  if (query.isError) {
    return (
      <ApiErrorAlert
        error={query.error}
        message={formatMessage({ id: 'attendance-page-error' })}
      />
    );
  }

  const { user, class: classData, signingForm, attendance } = query.data;
  const { subject } = classData;
  const locked = signingForm?.isLocked ?? false;

  function handleSave(entries: AttendanceInput[]) {
    saveMutation.mutate({ classId: classData.id, studentUserId: user.id, entries });
  }

  return (
    <>
      <PageHeader
        title={formatMessage({ id: 'attendance-page-title' })}
        subTitle={subject?.name}
      />
      {saveMutation.isError && (
        <ApiErrorAlert
          error={saveMutation.error}
          message={formatMessage({ id: 'attendance-save-error' })}
        />
      )}
      <AttendanceList
        entries={attendance}
        mode="student"
        readOnly={locked}
        isSaving={saveMutation.isLoading}
        onSave={handleSave}
      />
    </>
  );
}
